import { coreInitiativesSonarObjectsDeleteAsyncSlice } from './delete';
import { coreInitiativesSonarObjectsGetAsyncSlice } from './get';
import { coreInitiativesSonarObjectsPostAsyncSlice } from './post';

export const { requestDeleteCoreInitiativesSonarObjects, resetDeleteCoreInitiativesSonarObjects } =
	coreInitiativesSonarObjectsDeleteAsyncSlice.asyncActionCreators;

export const { requestGetCoreInitiativesSonarObjects, resetGetCoreInitiativesSonarObjects } =
	coreInitiativesSonarObjectsGetAsyncSlice.asyncActionCreators;

export const { requestPostCoreInitiativesSonarObjects, resetPostCoreInitiativesSonarObjects } =
	coreInitiativesSonarObjectsPostAsyncSlice.asyncActionCreators;
